import { html, nothing } from "lit-html";
import { Base } from "../../../shared/components/dialogs/Base";
import { translate } from "../../../shared/l10n/translate";
import { data } from "../../../shared/state/payload";
import { track } from "../../tracker/EventTracker";
import "../../dom/detectDevice";
import { travelData } from "@escapio/portal/state/travelData";
import { getPictureUrl } from "@escapio/shared/components/picture-url";
import { HOTEL_IMAGE_MAX_SIZE } from "@escapio/shared/components/picture-sizes";
import {
	PARAM_MTM_CAMPAIGN,
	PARAM_MTM_MEDIUM,
	PARAM_MTM_SOURCE,
} from "@escapio/portal/state/utm";
import xIcon from "@docroot/public/img/portal/adaptive/X_icon.svg";

const getSharingServices = pictureUrl => [
	{
		name: "x.com",
		url: `https://x.com/intent/tweet?via=Escapio&text=${translate(
			"sharing_message_x_com",
		)}:`,
		svg: xIcon,
		exclusive: true,
		addTrackingParameter: true,
	},
	{
		name: "WhatsApp",
		url: `whatsapp://send?text=${translate("sharing_message_whatsapp")}`,
		icon: "fa-whatsapp",
		exclusive: false,
		addTrackingParameter: false,
	},
	{
		name: "Facebook",
		url: "https://www.facebook.com/sharer/sharer.php?u=",
		icon: "fa-facebook",
		exclusive: true,
		addTrackingParameter: true,
	},
	{
		name: "Mail",
		url: `mailto:*?subject=${translate(
			"sharing_subject_email",
		)}&body=${translate("sharing_message_email")}`,
		icon: "fa-envelope",
		exclusive: false,
		addTrackingParameter: true,
	},
	{
		name: "Pinterest",
		url: `https://pinterest.com/pin/create/button/?media=${pictureUrl}&description=${translate(
			"sharing_message_pinterest",
		)}&url=`,
		icon: "fa-pinterest-p",
		exclusive: true,
		addTrackingParameter: true,
	},
];

const hotel = data.hotel;
const hotelUrl = `https://${window.location.hostname}${hotel.path}`;
const imageUrl = getPictureUrl(
	hotel.main_picture.filename,
	HOTEL_IMAGE_MAX_SIZE,
);

export class SharingDialog extends Base {
	onShow() {
		track("Hotel", "Teilen", `Layer geöffnet | ${hotel.id} | ${hotel.name}`);
	}

	getTemplateHeaderMiddle() {
		return html`<div class="sharing-dialog__header-icon"></div>`;
	}

	getTemplateContent() {
		const travelDataParams = travelData.formattedUrlParameter;
		return html`
			<div class="sharing-dialog__heading">
				${translate("sharing_dialog_title")}
			</div>
			<p class="sharing-dialog__text">${translate("sharing_dialog_text")}</p>
			<ul class="sharing-dialog__list">
				${getSharingServices(imageUrl)
					.filter(({ exclusive }) => !exclusive || hotel.also_exclusive_sharing)
					.map(({ name, url, addTrackingParameter, icon, svg }) => {
						const urlParams = addTrackingParameter
							? {
									[PARAM_MTM_SOURCE]: "Social",
									[PARAM_MTM_MEDIUM]: name,
									[PARAM_MTM_CAMPAIGN]: "sbp",
								}
							: {};
						const completeHotelUrl = new URL(hotelUrl);
						Object.entries(urlParams).forEach(([key, value]) => {
							if (value !== undefined) {
								completeHotelUrl.searchParams.set(key, value);
							}
						});
						completeHotelUrl.hash = travelDataParams;

						const urlWithTrackingParam = `${url}${encodeURIComponent(
							completeHotelUrl,
						)}`;
						return html`<li>
							<esc-click-tracker
								category="Hotel"
								action="Teilen"
								label="Geteilt | ${hotel.id} | ${hotel.name} | ${name}"
							>
								<a
									href=${urlWithTrackingParam}
									class="sharing-dialog__link"
									target="_blank"
									rel="noopener"
								>
									${
										icon
											? html`<span
													class="fa ${icon} sharing-dialog__icon sharing-dialog__icon--${name.toLowerCase()}"
												></span>`
											: nothing
									}
									${svg ? svg : nothing} ${name}
								</a>
							</esc-click-tracker>
						</li>`;
					})}
			</ul>
		`;
	}
}
